import {Injectable} from "@angular/core";
import {IClientModel} from "../../models/clients/clients.model";
import {ApplicationUser} from "../ApplicationUser";
import {RoleTypes, Roles} from "../../models/roles";

import * as _ from "lodash";
import * as moment from "moment/moment";


@Injectable()
export class PermissionsService {

    constructor(public user: ApplicationUser) {

    }

    public permissions = {
        'dashboards.switchUser': function () {
            let appUser = this.user;

            if (appUser && appUser.hasRole([RoleTypes.OWNER])) return true;

            if (appUser && appUser.user && appUser.originalUser && appUser.originalUser.id !== appUser.user.id) return true;
            
            return false;
        }

    };

    public can(permission) {

        if (!this.user.loggedIN || !this.user.user) return false;

        if (this.user.user.permissions && this.user.user.permissions.indexOf(permission) > -1) {
            return true;
        }

        if (this.permissions[permission]) {
            return this.permissions[permission].apply(this);
        }

        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/services/permissions/permissions.service.ts